module.exports = __webpack_public_path__ + "media/images/landing/alita_banner-06df280e52274666cc0e214d9808464d.jpg";